module.exports = __webpack_public_path__ + "static/media/demoBodyType.28af9028.png";